"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExporterBaseWithRootElement = exports.BaseExporter = void 0;
var tslib_1 = require("tslib");
var string_1 = require("@devexpress/utils/lib/utils/string");
var xml_writer_1 = require("../../zip/xml-writer");
var BaseExporter = (function () {
    function BaseExporter(data) {
        this.data = data;
    }
    Object.defineProperty(BaseExporter.prototype, "writer", {
        get: function () { return this.data.writer; },
        enumerable: false,
        configurable: true
    });
    return BaseExporter;
}());
exports.BaseExporter = BaseExporter;
var ExporterBaseWithRootElement = (function (_super) {
    tslib_1.__extends(ExporterBaseWithRootElement, _super);
    function ExporterBaseWithRootElement() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ExporterBaseWithRootElement.prototype.export = function () {
        var rootElementName = (string_1.StringUtils.isNullOrEmpty(this.rootNSPrefix) ? '' : this.rootNSPrefix + ":") + this.rootElement;
        this.data.writer = new xml_writer_1.XmlWriter(this.data.constants).initNS(rootElementName, this.rootNSValue);
        this.fillWriter();
        if (this.isWriteToZip())
            this.writeToZip(this.filePath, this.writer);
        this.data.popWriter();
    };
    Object.defineProperty(ExporterBaseWithRootElement.prototype, "rootNSPrefix", {
        get: function () { return ''; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ExporterBaseWithRootElement.prototype, "rootNSValue", {
        get: function () { return ''; },
        enumerable: false,
        configurable: true
    });
    ExporterBaseWithRootElement.prototype.isWriteToZip = function () { return true; };
    ExporterBaseWithRootElement.prototype.writeToZip = function (filePath, writer) {
        this.data.zipBuilder.addFile(filePath, writer);
    };
    return ExporterBaseWithRootElement;
}(BaseExporter));
exports.ExporterBaseWithRootElement = ExporterBaseWithRootElement;
